import { RoomingListEvent } from '@marriott/mi-groups-graphql';
import { Control, DeepMap, FieldValues } from 'react-hook-form';

export type EventInfoProps = {
  variant: EventInfoVariant;
  eventInfo: EventInfoLabels;
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  control: Control<any>;
  setValue: (name: string, value: string) => void;
  setEventData?: (eventData: RoomingListEvent | null) => void;
  showRequiredError?: boolean;
  errors: DeepMap<FieldValues, 'string'>;
  clearErrors: (error?: string | string[] | undefined) => void;
  setError: (name: string, value: { type: string; message: string }) => void;
  onApiError: (isError: boolean) => void;
};

export enum EventInfoVariant {
  CREATE_EVENT,
  MODIFY_EVENT,
  UPLOAD_TO_MARSHA,
}

export type EventInfoLabels = {
  heading?: string;
  miniHotelCodeLabel: string;
  miniHotelCodeLabelDtt: string;
  miniHotelCodeRequiredError: string;
  miniHotelCodeRequiredErrorDtt: string;
  miniHotelInvalidError: string;
  miniHotelInvalidErrorDtt: string;
  miniHotelCodeHelperText: string;
  miniHotelCodeHelperTextDtt: string;
  eventDatesLabel: string;
  eventDatesHelperLabel: string;
  eventNameLabel: string;
};
